<div class="my-tickets-container">
  @if (ticketsRequestStatus.isNone) {
    <div>
      @if (cards.get(StatusTicketCard.ACTIVE)) {
        <app-expansion-panel [opened]="true">
          <app-expansion-panel-header>Voos Ativos</app-expansion-panel-header>
          <app-expansion-panel-body>
            @for (ticket of ticketMapActive | keyvalue; track trackByTicketNumber($index, ticket)) {
              <!-- AQUI SE CONTROLA QUE DOS VUELOS ESTEN ASOCIADOS POR PNR  -->
              @if (ticket.value.length == 2) {
                <app-card-ticket-multi
                  [ticket1]="ticket.value[0]"
                  [ticket2]="ticket.value[1]"
                  [status]="StatusTicketCard.ACTIVE">
                </app-card-ticket-multi>
              }
              <!-- AQUI SE CONTROLA QUE 4 VUELOS ESTEN ASOCIADOS POR PNR -->
              @if (ticket.value.length == 4) {
                <app-card-ticket-multi
                  [ticket1]="ticket.value[0]"
                  [ticket2]="ticket.value[1]"
                  [status]="StatusTicketCard.ACTIVE">
                </app-card-ticket-multi>
                <app-card-ticket-multi
                  [ticket1]="ticket.value[2]"
                  [ticket2]="ticket.value[3]"
                  [status]="StatusTicketCard.ACTIVE">
                </app-card-ticket-multi>
              }
              <!-- AQUI SE CONTROLA QUE 3 VUELOS ESTEN ASOCIADOS POR PNR -->
              @if (ticket.value.length == 3) {
                <app-card-ticket-triple
                  [ticket1]="ticket.value[0]"
                  [ticket2]="ticket.value[1]"
                  [ticket3]="ticket.value[2]"
                  [status]="StatusTicketCard.ACTIVE">
                </app-card-ticket-triple>
              }
              @if (ticket.value.length == 1) {
                <app-card-ticket
                  [ticket]="ticket.value[0]"
                  [status]="StatusTicketCard.ACTIVE">
                </app-card-ticket>
              }
            }
          </app-expansion-panel-body>
        </app-expansion-panel>
      }
      @if (cards.get(StatusTicketCard.CANCELLED)) {
        <app-expansion-panel>
          <app-expansion-panel-header>Voos Cancelados</app-expansion-panel-header>
          <app-expansion-panel-body>
            @for (ticket of ticketMapCancelled | keyvalue; track trackByTicketNumber($index, ticket)) {
              <!-- AQUI SE CONTROLA QUE DOS VUELOS ESTEN ASOCIADOS POR PNR  -->
              @if (ticket.value.length == 2) {
                <app-card-ticket-multi
                  [ticket1]="ticket.value[0]"
                  [ticket2]="ticket.value[1]"
                  [status]="StatusTicketCard.CANCELLED">
                </app-card-ticket-multi>
              }
              <!-- AQUI SE CONTROLA QUE 4 VUELOS ESTEN ASOCIADOS POR PNR -->
              @if (ticket.value.length == 4) {
                <app-card-ticket-multi
                  [ticket1]="ticket.value[0]"
                  [ticket2]="ticket.value[1]"
                  [status]="StatusTicketCard.CANCELLED">
                </app-card-ticket-multi>
                <app-card-ticket-multi
                  [ticket1]="ticket.value[2]"
                  [ticket2]="ticket.value[3]"
                  [status]="StatusTicketCard.CANCELLED">
                </app-card-ticket-multi>
              }
              <!-- AQUI SE CONTROLA QUE 3 VUELOS ESTEN ASOCIADOS POR PNR -->
              @if (ticket.value.length == 3) {
                <app-card-ticket-triple
                  [ticket1]="ticket.value[0]"
                  [ticket2]="ticket.value[1]"
                  [ticket3]="ticket.value[2]"
                  [status]="StatusTicketCard.CANCELLED">
                </app-card-ticket-triple>
              }
              @if (ticket.value.length == 1) {
                <app-card-ticket
                  [ticket]="ticket.value[0]"
                  [status]="StatusTicketCard.CANCELLED">
                </app-card-ticket>
              }
            }
          </app-expansion-panel-body>
        </app-expansion-panel>
      }
      @if (cards.get(StatusTicketCard.INACTIVE)) {
        <app-expansion-panel class="tickets_inactive">
          <app-expansion-panel-header>Histórico de Voos</app-expansion-panel-header>
          <app-expansion-panel-body>
            @for (ticket of ticketMapInactive | keyvalue; track trackByTicketNumber($index, ticket)) {
              <!-- AQUI SE CONTROLA QUE DOS VUELOS ESTEN ASOCIADOS POR PNR  -->
              @if (ticket.value.length == 2) {
                <app-card-ticket-multi
                  [ticket1]="ticket.value[0]"
                  [ticket2]="ticket.value[1]"
                  [status]="StatusTicketCard.INACTIVE">
                </app-card-ticket-multi>
              }
              <!-- AQUI SE CONTROLA QUE 4 VUELOS ESTEN ASOCIADOS POR PNR -->
              @if (ticket.value.length == 4) {
                <app-card-ticket-multi
                  [ticket1]="ticket.value[0]"
                  [ticket2]="ticket.value[1]"
                  [status]="StatusTicketCard.INACTIVE">
                </app-card-ticket-multi>
                <app-card-ticket-multi
                  [ticket1]="ticket.value[2]"
                  [ticket2]="ticket.value[3]"
                  [status]="StatusTicketCard.INACTIVE">
                </app-card-ticket-multi>
              }
              <!-- AQUI SE CONTROLA QUE 3 VUELOS ESTEN ASOCIADOS POR PNR -->
              @if (ticket.value.length == 3) {
                <app-card-ticket-triple
                  [ticket1]="ticket.value[0]"
                  [ticket2]="ticket.value[1]"
                  [ticket3]="ticket.value[2]"
                  [status]="StatusTicketCard.INACTIVE">
                </app-card-ticket-triple>
              }
              @if (ticket.value.length == 1) {
                <app-card-ticket
                  [ticket]="ticket.value[0]"
                  [status]="StatusTicketCard.INACTIVE">
                </app-card-ticket>
              }
            }
          </app-expansion-panel-body>
        </app-expansion-panel>
      }
    </div>
  }

  @if (ticketsRequestStatus.isLoading) {
    <app-loading></app-loading>
  }
</div>